var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLongLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.151,
    height: 19.949,
    viewBox: "0 0 41.151 19.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17780",
    "data-name": "Path 17780",
    d: "M36.559,26.683H2.066l5.891,5.891a1.508,1.508,0,1,1-2.133,2.133l-8.465-8.465a1.5,1.5,0,0,1-.1-.112c-.013-.016-.025-.033-.037-.049s-.035-.045-.051-.069-.026-.042-.039-.064-.026-.041-.037-.063-.022-.045-.032-.067-.021-.044-.031-.066-.017-.045-.025-.067-.018-.047-.025-.072-.012-.046-.018-.069-.013-.049-.018-.074-.009-.054-.012-.081-.007-.043-.009-.064a1.523,1.523,0,0,1,0-.3c0-.022.006-.043.009-.064s.007-.054.012-.081.012-.049.018-.074.011-.046.018-.069.017-.048.025-.072.015-.045.025-.067.02-.044.031-.066.021-.045.032-.067.025-.042.037-.063.025-.043.039-.064.034-.046.051-.069.024-.033.037-.049a1.5,1.5,0,0,1,.1-.112l8.465-8.465a1.508,1.508,0,1,1,2.133,2.133L2.066,23.666H36.559a1.508,1.508,0,0,1,0,3.017Z",
    transform: "translate(3.084 -15.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongLeft);
export default __webpack_public_path__ + "static/media/arrow-long-left.c040bdaad864e7de8b258387f0190cff.svg";
export { ForwardRef as ReactComponent };